import React from 'react';
import { Toaster } from './ui/sonner';
import { useTheme } from '../context/ThemeContext';

const ThemeAwareToaster = () => {
  const { isDark } = useTheme();

  return (
    <Toaster
      position="top-right"
      richColors
      expand={true}
      duration={6000}
      closeButton
      theme={isDark ? 'dark' : 'light'}
      toastOptions={{
        style: {
          minWidth: '350px',
        },
      }}
    />
  );
};

export default ThemeAwareToaster;
